import {
  LoadingState,
  loadingReducer
} from '@ocean-club/dapps/dist/modules/loading/reducer'
import {
  FetchNFTsRequestAction,
  FetchNFTsSuccessAction,
  FetchNFTsFailureAction,
  FETCH_NFTS_REQUEST,
  FETCH_NFTS_SUCCESS,
  FETCH_NFTS_FAILURE
} from '../nft/actions'
import { Account } from './types'

export type AccountState = {
  data: Record<string, Account>
  loading: LoadingState
  error: string | null
}

const INITIAL_STATE = {
  data: {},
  loading: [],
  error: null
}

type AccountReducerAction =
  | FetchNFTsRequestAction
  | FetchNFTsSuccessAction
  | FetchNFTsFailureAction

export function accountReducer(
  state: AccountState = INITIAL_STATE,
  action: AccountReducerAction
): AccountState {
  switch (action.type) {
    case FETCH_NFTS_REQUEST: {
      return {
        ...state,
        loading: loadingReducer(state.loading, action)
      }
    }
    case FETCH_NFTS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.accounts.reduce((obj, account) => {
            obj[account.address] = account
            return obj
          }, {} as Record<string, Account>)
        },
        loading: loadingReducer(state.loading, action),
        error: null
      }
    }
    case FETCH_NFTS_FAILURE: {
      return {
        ...state,
        loading: loadingReducer(state.loading, action),
        error: action.payload.error
      }
    }
    default:
      return state
  }
}
